import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Strip ", BC [postal], Canada" / ", British Columbia, Canada" tail for customer-facing views.
export function formatLocalAddress(addr) {
  if (!addr) return "";
  return addr
    .replace(/,\s*(British Columbia|BC)[^,]*,\s*Canada\s*$/i, "")
    .replace(/,\s*Canada\s*$/i, "")
    .replace(/,\s*(British Columbia|BC)(\s+[A-Z]\d[A-Z]\s*\d[A-Z]\d)?\s*$/i, "")
    .trim();
}
